// src/components/Inputs/SalaryCalculator/OvertimeInput.jsx
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

const OvertimeInput = ({ overtimeValue, onOvertimeValueChange, salary, config }) => {
  // Calculate the maximum overtime such that salary + overtime <= 200000.
  const maxOvertime = Math.max(0, config.MAX_SALARY - salary);

  const handleTextFieldChange = (event) => {
    let value = Number(event.target.value);
    if (value > maxOvertime) {
      value = maxOvertime;
    }
    onOvertimeValueChange(value);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Overtime
      </Typography>
      <TextField
        label="Overtime Value"
        type="number"
        value={overtimeValue === 0 ? '' : overtimeValue}
        onChange={handleTextFieldChange}
        inputProps={{ min: 0, max: maxOvertime }}
        variant="outlined"
        fullWidth
      />
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
        Note: This calculator supports a maximum total income (salary plus overtime) of £200,000 per annum.
      </Typography>
    </Box>
  );
};

export default OvertimeInput;
